import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import rest from '../axios';
import './css/CondominiumComponent.css';

const CondominiumComponent = () => {
  const [condominios, setCondominios] = useState([]);
  const [cidade, setCities] = useState([]);
  const [bairro, setNeighborhoods] = useState([]);
  const [search, setSearch] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedCondo, setSelectedCondo] = useState({ name: '', city_id: '', neighborhood_id: '' });
  const [newCondo, setNewCondo] = useState({ name: '', city_id: '', neighborhood_id: '' });

  const fetchData = async () => {
    try {
      const [condRes, cityRes] = await Promise.all([
        rest.get('/admin/communities'),
        rest.get('/cities')
      ]);
      setCondominios(condRes.data?.data.communities || []);
      setCities(cityRes.data?.data || []); 
    } catch (err) {
      console.error('Erro ao buscar dados:', err);
    }
  };

  const fetchNeighborhoods = async (cityId) => {
    if (!cityId) return setNeighborhoods([]);
    try {
      const res = await rest.get(`/neighborhoods/city/${cityId}`);
      setNeighborhoods(res.data?.data || []); 
    } catch (err) {
      console.error('Erro ao buscar bairros:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e, type = 'edit') => {
    const { name, value } = e.target;
    if (type === 'edit') {
      setSelectedCondo(prev => ({ ...prev, [name]: value }));
    } else {
      setNewCondo(prev => ({ ...prev, [name]: value }));
    }

    if (name === 'city_id') {
      fetchNeighborhoods(value);  
    }
  };

  const filtered = condominios.filter(c => {
    const text = `${c.name} ${c.city_id} ${c.neighborhood_id}`.toLowerCase();
    return text.includes(search.toLowerCase());
  });

  const handleEdit = (condo) => {
    setSelectedCondo(condo);
    fetchNeighborhoods(condo.city_id); 
    setShowEditModal(true);
  };

  const handleDelete = (condo) => {
    setSelectedCondo(condo);
    setShowDeleteModal(true);
  };

  const handleSaveEdit = async () => {
    try {
      await rest.put(`/admin/communities/${selectedCondo.id}`, selectedCondo);
      fetchData();
      setShowEditModal(false);
    } catch (error) {
      console.error('Erro ao salvar edição:', error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await rest.delete(`/admin/communities/${selectedCondo.id}`);
      fetchData();
      setShowDeleteModal(false);
    } catch (error) {
      console.error('Erro ao excluir condomínio:', error);
    }
  };

  const handleAddCondo = async () => {
    const payload = {
      name: newCondo.name,
      city_id: Number(newCondo.city_id),
      neighborhood_id: Number(newCondo.neighborhood_id)
    }
    try {
      await rest.post('/admin/communities', payload);
      fetchData();
      setShowAddModal(false);
      setNewCondo({ name: '', city_id: '', neighborhood_id: '' });
    } catch (error) {
      console.error('Erro ao adicionar condomínio:', error);
    }
  };

  return (

      <div className="container mt-4">
        <h1>Lista de Condomínios</h1>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Pesquisar por nome, cidade ou bairro..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <Button className="mb-3" onClick={() => setShowAddModal(true)}>Adicionar Condomínio</Button>
        <table className="table mt-4">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cidade</th>
              <th>Bairro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(condo => (
              <tr key={condo.id}>
                <td>{condo.name}</td>
                <td>{condo.cityName}</td>
                <td>{condo.neighborhoodName}</td>
                <td>
                  <Button variant="warning" size="sm" onClick={() => handleEdit(condo)}>Editar</Button>{' '}
                  <Button variant="danger" size="sm" onClick={() => handleDelete(condo)}>Excluir</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal Edição */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Condomínio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nome</Form.Label>
                <Form.Control name="name" value={selectedCondo.name} onChange={(e) => handleInputChange(e, 'edit')} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Cidade</Form.Label>
                <Form.Select name="city_id" value={selectedCondo.city_id} onChange={(e) => handleInputChange(e, 'edit')}>
                  <option value="">Selecione a cidade</option>
                  {cidade.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Bairro</Form.Label>
                <Form.Select name="neighborhood_id" value={selectedCondo.neighborhood_id} onChange={(e) => handleInputChange(e, 'edit')}>
                  <option value="">Selecione o bairro</option>
                  {bairro.map((b) => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancelar</Button>
            <Button variant="primary" onClick={handleSaveEdit}>Salvar</Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Exclusão */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar Exclusão</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Tem certeza de que deseja excluir o condomínio <strong>{selectedCondo.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</Button>
            <Button variant="danger" onClick={handleConfirmDelete}>Excluir</Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Adição */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Adicionar Condomínio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nome</Form.Label>
                <Form.Control name="name" value={newCondo.name} onChange={(e) => handleInputChange(e, 'add')} placeholder="Nome do Condomínio" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Cidade</Form.Label>
                <Form.Select name="city_id" value={newCondo.city_id} onChange={(e) => handleInputChange(e, 'add')}>
                  <option value="">Selecione a cidade</option>
                  {cidade.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Bairro</Form.Label>
                <Form.Select name="neighborhood_id" value={newCondo.neighborhood_id} onChange={(e) => handleInputChange(e, 'add')}>
                  <option value="">Selecione o bairro</option>
                  {bairro.map((b) => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancelar</Button>
            <Button variant="primary" onClick={handleAddCondo}>Adicionar</Button>
          </Modal.Footer>
        </Modal>
      </div>

  );
};

export default CondominiumComponent;
